import { render } from "./SignoutModal.vue?vue&type=template&id=6628e672&lang=true"
import script from "./SignoutModal.vue?vue&type=script&lang=js"
export * from "./SignoutModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__